import { ChangeEvent, useState, useEffect, cloneElement, FC, ReactElement, Fragment } from 'react';
import {
    AppBar,
    Container,
    useScrollTrigger,
    Box,
    IconButton,
} from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { Menu as MenuIcon } from '@mui/icons-material';
import { DeloitteLogoButton, DeloitteTab, DeloitteTabs, DeloitteToolbar } from 'TaxAnalyticsUI/Deloitte';
import { useHistory, useLocation } from 'react-router-dom';
import { UserMenu, UserAvatar } from '../userMenu/userMenu';
import DrawerMenu from './DrawerMenu';
import ContactForm from './ContactForm';
import { AuthComponentProps, withAuthProvider } from '../../hoc/auth/AuthProvider';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { tag } from 'TaxAnalyticsHelpers/ATInternet';

const tabs = [
    {
        index: 0,
        label: "Accueil",
        path: "/"
    },
    {
        index: 1,
        label: "Not méthodologie",
        path: "/methodo"
    },
    {
        index: 2,
        label: "Nous contacter",
        action: "contact"
    }
];

const useStyles = makeStyles((theme) => {
    return ({
        appBar: {
            zIndex: theme.zIndex.drawer + 2,
            backgroundColor: theme.palette.background.default
        },
        grow: {
            flexGrow: 1,
        },
        menuButton: {
            marginRight: theme.spacing(2),
        },
        title: {
            display: 'none',
            [theme.breakpoints.up('sm')]: {
                display: 'block',
            },
        },
        sectionDesktop: {
            display: 'none',
            [theme.breakpoints.up('md')]: {
                display: 'flex',
                alignItems: 'center'
            },
        },
        sectionMobile: {
            display: 'flex',
            [theme.breakpoints.up('md')]: {
                display: 'none',
            },
        },
        autoSizeImg: {
            maxWidth: '100%',
            maxHeight: '100%'
        },
        gutters: {
            paddingLeft: 8,
            paddingRight: 8
        },
        tabLabel: {
            textTransform: 'none'
        },
        avatar: {
            color: theme.palette.common.white,
            backgroundColor: theme.palette.secondary.main,
        }
    }
    )
});

const ElevationScroll: FC = (props) => {
    const { children } = props;
    const trigger = useScrollTrigger({
        disableHysteresis: true,
        threshold: 0
    });

    return cloneElement(children as ReactElement<any>, {
        elevation: trigger ? 4 : 0,
    });
}

const NavBar: FC<AuthComponentProps> = (props) => {
    const classes = useStyles();
    const history = useHistory();
    const { user } = props;
    const [drawerOpened, setDrawerOpened] = useState(false);

    const toggleDrawerOpened = () => setDrawerOpened(!drawerOpened);

    const [tabValue, setTabValue] = useState(0);
    const [openModal, setOpenModal] = useState(false);
    const location = useLocation();
    const handleChange = (event: ChangeEvent<{}>, newValue: number) => {
        var tab = tabs.find(t => t.index === newValue);
        if (tab && tab.path)
            history.push(tab.path);
        if (tab && tab.action) {
            setOpenModal(true);
            tag.sendClick({
                name: `Home - Contact`
            });
        }
    };

    useEffect(() => {
        var tab = tabs.find(t => t.path === location.pathname);
        if (tab) {
            setTabValue(tab.index);
        }
        else {
            setTabValue(tabs.length);
        }

    }, [location]);

    return (
        <Fragment>
            <GoogleReCaptchaProvider
                reCaptchaKey={process.env.REACT_APP_RECAPTCHA_PUBLIC_KEY!}
            >
                <ContactForm open={openModal} closeCallback={() => setOpenModal(false)} />
            </GoogleReCaptchaProvider>
            <ElevationScroll {...props}>
                <AppBar className={classes.appBar}>
                    <Container maxWidth="lg">
                        <DeloitteToolbar>
                            <DeloitteLogoButton />
                            <div className={classes.grow} />
                            <Box className={classes.sectionDesktop}>
                                <Box mx={4}>
                                    <DeloitteTabs value={tabValue} onChange={handleChange} aria-label="navigation">
                                        <DeloitteTab label="Accueil" />
                                        <DeloitteTab label="Notre méthodologie" />
                                        <DeloitteTab label="Nous contacter" />
                                        <DeloitteTab label="Fake" fake />
                                    </DeloitteTabs>
                                </Box>
                                <UserMenu />
                            </Box>
                            <div className={classes.sectionMobile}>
                                {!user.isAuthenticated &&
                                    <IconButton
                                        aria-label="show more"
                                        aria-haspopup="true"
                                        onClick={() => toggleDrawerOpened()}
                                        color="inherit"
                                        size="large">
                                        <MenuIcon />
                                    </IconButton>
                                }
                                {user.isAuthenticated &&
                                    <UserAvatar user={user} onClick={() => toggleDrawerOpened()} />
                                }
                            </div>
                        </DeloitteToolbar>
                    </Container>
                </AppBar>
            </ElevationScroll>
            <DrawerMenu opened={drawerOpened} toggleDrawerHandler={toggleDrawerOpened} updateTab={handleChange} />
            <DeloitteToolbar />
        </Fragment>
    );
}

export default withAuthProvider(NavBar, true);